export const debounce = <F extends (...args: unknown[]) => void>(
  func: F,
  wait = 100,
) => {
  let timeoutID: NodeJS.Timeout
  return function (this: unknown, ...args: Parameters<F>) {
    clearTimeout(timeoutID)
    timeoutID = setTimeout(() => func.apply(this, args), wait)
  } as F
}

export const asyncDebounce = <
  F extends (...args: unknown[]) => Promise<unknown>,
>(
  func: F,
  wait?: number,
) => {
  const debounced = debounce(
    (
      resolve: (value: unknown) => unknown,
      reject: (value: unknown) => unknown,
      args: Parameters<F>,
    ) => {
      func(...args)
        .then(resolve)
        .catch(reject)
    },
    wait,
  )

  return (...args: Parameters<F>): ReturnType<F> =>
    new Promise((resolve, reject) => {
      debounced(resolve, reject, args)
    }) as ReturnType<F>
}
